import request from '@/utils/request';
import { getUrlByGeneralInYinyitong } from '@/utils/defaultParameter';

const serviceName = 'datasync-dataviewsimulator';
const controllerName = 'yinyitong';

/**
 * 支付订单发起
 * @param {*} data
 * @returns
 */
export function paymentOrderInitiation(data) {
  const interfaceName = 'paymentOrderInitiation';
  const url = getUrlByGeneralInYinyitong(serviceName, controllerName, interfaceName);
  return request({
    url,
    method: 'post',
    data
  });
}

/**
 * 定时轮询查询支付状态
 * @param {*} data
 * @returns
 */
export function timedPollingOfPaymentStatus(data) {
  const interfaceName = 'timedPollingOfPaymentStatus';
  const url = getUrlByGeneralInYinyitong(serviceName, controllerName, interfaceName);
  return request({
    url,
    method: 'get',
    params: data
  });
}
